/** Primary site owner · protected from suspension and role demotion by other admins. */
export const SITE_OWNER_EMAIL = "mohammedlk27@gmail.com";

export function isSiteOwnerEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.trim().toLowerCase() === SITE_OWNER_EMAIL;
}
